import Contacts from '../components/ContactDetails'


export default Contacts;